import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { formatPrice } from '@codex/helpers';
import translations from '../../translations';

const themeRed = {
  backgroundColor: '#c90404',
  borderBottomColor: '#830101'
};

const themeBlue = {
  backgroundColor: '#4855a0',
  borderBottomColor: '#55589b'
};

const themeGray = {
  backgroundColor: '#666666',
  borderBottomColor: '#333333'
};

const StyledRibbon = styled.div`
  position: relative;
  left: -6px;
  top: 30px;
  width: 99px;
  padding: 2px 10px 3px 15px;
  font-family: Helvetica;
  font-size: 13px;
  background-color: ${(props) => props.theme.backgroundColor};
  color: #fff;

  @media ${(props) => props.theme.breakpoints.mobile} {
    top: 27px;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -4px;
    border: 4px solid;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
    transform: rotate(45deg);
    left: 2px;
    border-bottom-color: ${(props) => props.theme.borderBottomColor};
  }
`;

const Ribbon = ({ price, currency, isActualProduct }) => {
  if (isActualProduct) {
    return (
      <ThemeProvider theme={themeGray}>
        <StyledRibbon>
          {translations.actualHeader}
        </StyledRibbon>
      </ThemeProvider>
    );
  }

  const formattedPrice = formatPrice(Math.round(Math.abs(price)).toString(), true, currency);
  if (price < 0) {
    return (
      <ThemeProvider theme={themeRed}>
        <StyledRibbon>
          For
          {' '}
          {formattedPrice}
          {' '}
          <strong>less</strong>
        </StyledRibbon>
      </ThemeProvider>
    );
  } if (price > 0) {
    return (
      <ThemeProvider theme={themeBlue}>
        <StyledRibbon>
          For
          {' '}
          {formattedPrice}
          {' '}
          <strong>more</strong>
        </StyledRibbon>
      </ThemeProvider>
    );
  }
  return null;


};

Ribbon.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  isActualProduct: PropTypes.bool
};

Ribbon.defaultProps = {
  isActualProduct: false
};

export default Ribbon;
